import { create } from 'zustand';
import { persist } from 'zustand/middleware';

/**
 * Auth Store - Manages user authentication
 * 
 * Replaces scattered localStorage calls with centralized state
 */
export const useAuthStore = create(
  persist(
    (set, get) => ({
      // State
      currentUser: null,
      activeOrgId: null,
      activeSiteId: null,
      
      // Actions
      login: (loginResponse) => {
        set({
          currentUser: {
            id: loginResponse.user.id,
            email: loginResponse.user.email,
            name: loginResponse.user.name,
            global_role: loginResponse.user.global_role,
          },
        });
      },
      
      // ✅ ADDED: setCurrentUser method
      setCurrentUser: (user) => {
        set({
          currentUser: user,
        });
      },
      
      logout: () => {
        set({
          currentUser: null,
          activeOrgId: null,
          activeSiteId: null,
        });
        localStorage.clear();
      },
      
      setActiveOrg: (orgId) => {
        set({ activeOrgId: orgId, activeSiteId: null });
      },
      
      setActiveSite: (siteId) => {
        set({ activeSiteId: siteId });
      },
    }),
    {
      name: 'viewmax-auth', // localStorage key
    }
  )
);

// Helper for permissions
export function usePermissions() {
  const currentUser = useAuthStore(s => s.currentUser);

  if (!currentUser) {
    return {
      isPlatformAdmin: false,
      canManageCameras: false,
    };
  }

  return {
    isPlatformAdmin: currentUser.global_role === 'platform_admin',
    canManageCameras: currentUser.global_role === 'platform_admin',
  };
}
